import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, IdentityProvider } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editIdentityProvider(
    request: Boundaries["editIdentityProvider"]["request"],
  ): void;
}

function useEditIdentityProvider(
  identityProvider: Identifiable<IdentityProvider>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditIdentityProviderRequestPending(identityProvider),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditIdentityProviderRequestSuccess(identityProvider),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditIdentityProviderRequestFailure(identityProvider),
    ),
    editIdentityProvider: core.editIdentityProvider,
  };
}

export { useEditIdentityProvider };
